import { Modals } from '@/constants';

import { AppModal } from '../AppModal';
import { ShareWithAFriendModalContent } from './ShareWithAFriendModalContent';

export const ShareWithAFriendModal = () => {
  return (
    <AppModal
      modalName={Modals.SHARE_WITH_A_FRIEND}
      maxWidth={false}
      scroll="paper"
      transparentBackground>
      <ShareWithAFriendModalContent />
    </AppModal>
  );
};
